import * as React from 'react';
import Dialog from 'material-ui/Dialog';
import Login from './login';

type Props = {
  readonly reLoginModalOpen: boolean
};

type States = {
  readonly reLoginModalOpen: boolean
};

class ReLoginComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);
  }

  componentWillUnmount() {
    this.setState({reLoginModalOpen: false});
  }

  render() {
    return(
      <Dialog
        actions={[]}
        modal={true}
        open={this.props.reLoginModalOpen}
        contentStyle={{width: 400}}
        style={{zIndex: 2000}}
      >
        <Login isReLogin={true} fromEmailVerification={false} />
      </Dialog>
    );
  }
}

export default ReLoginComponent;



// WEBPACK FOOTER //
// ./src/auth/ReLoginComponent.tsx